// extracted by mini-css-extract-plugin
export var contentBody = "_5t-9";
export var headerImage = "_5t-2";
export var imageButton = "_5t-7";
export var imageButtonIcon = "_5t-8";
export var imageHeader = "_5t-4";
export var imageHeaderText = "_5t-5";
export var imageOverlay = "_5t-3";
export var imageTitle = "_5t-6";
export var imageWrapper = "_5t-1";
export var taskList = "_5t-a";
export var widget = "_5t-0";